import { createContext, useContext } from "react";
import { E2bProfileResponseProfileEnum } from "@/lib/api/generated/casedb";

/**
 * The catalog declaration profiles that apply on every installation: the core entries, which the
 * generated schema marks ICH. The review markers use this set until the server answers.
 */
export const CORE_DECLARATION_PROFILES: readonly string[] = [E2bProfileResponseProfileEnum.Ich];

/**
 * The declaration profiles of this installation (`GET /api/v1/e2b/profile`): `["ICH"]` on ICH,
 * `["ICH", "FDA"]` on FDA. The workspace provides it; a table outside the workspace sees the core.
 */
export const E2bDeclarationProfilesContext = createContext<readonly string[]>(CORE_DECLARATION_PROFILES);

/** The declaration profiles the E2B "required" marker follows. */
export function useE2bDeclarationProfilesInView(): readonly string[] {
  return useContext(E2bDeclarationProfilesContext);
}
